import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Departments() {
  const [depts, setDepts] = useState([]);
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    (async () => {
      const [d, b] = await Promise.all([api.get("/departments"), api.get("/brands")]);
      setDepts(d.data);
      setBrands(b.data);
    })();
  }, []);

  return (
    <div data-testid="departments-page" className="max-w-[1600px] mx-auto px-6 lg:px-12 py-24">
      <div className="label-eyebrow mb-6 text-[var(--ff-red)]">▮ NETWORK / DEPARTMENTS</div>
      <h1 className="font-display text-5xl lg:text-8xl mb-4 max-w-5xl">DEPARTMENTS &amp; BRANDS</h1>
      <p className="text-[var(--ff-text-dim)] text-lg max-w-3xl mb-20">
        Every brand under Freshy Fresh is organized into a department. Each department operates independently while sharing the resources of the larger network.
      </p>

      <div className="space-y-24">
        {depts.map((d, idx) => {
          const deptBrands = brands.filter((b) => b.department_id === d.id);
          return (
            <div key={d.id} data-testid={`department-${idx}`}>
              <div className="grid lg:grid-cols-12 gap-8 mb-10 border-t border-[var(--ff-border)] pt-10">
                <div className="lg:col-span-1 font-mono-ui text-sm text-[var(--ff-red)]">
                  {String(idx + 1).padStart(2, "0")}
                </div>
                <div className="lg:col-span-5">
                  <h2 className="font-display text-4xl lg:text-5xl">{d.name}</h2>
                </div>
                <div className="lg:col-span-6 text-[var(--ff-text-dim)] text-base leading-relaxed">
                  {d.description}
                </div>
              </div>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--ff-border)]">
                {deptBrands.map((b) => (
                  <div key={b.id} className="bg-[var(--ff-surface)] p-8 hover:bg-[var(--ff-surface-hover)] transition-colors flex flex-col" data-testid={`brand-${b.id}`}>
                    <div className="flex items-start justify-between mb-3">
                      <div className="label-eyebrow">BRAND</div>
                      {b.logo_url && (
                        <img src={b.logo_url} alt={`${b.name} logo`} className="w-14 h-14 object-contain bg-white p-1" />
                      )}
                    </div>
                    <div className="font-display text-2xl mb-3">{b.name}</div>
                    <p className="text-sm text-[var(--ff-text-dim)] flex-1">{b.description}</p>
                    {b.website && (
                      <a href={b.website} target="_blank" rel="noreferrer" className="mt-4 inline-block font-mono-ui text-xs text-[var(--ff-red)]">VISIT →</a>
                    )}
                  </div>
                ))}
                {deptBrands.length === 0 && (
                  <div className="bg-[var(--ff-surface)] p-8 text-[var(--ff-text-dim)] italic md:col-span-3">No brands listed under this department yet.</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
